import { Api } from "@penn/web-common";
import { unwrap } from "@penn/web-common";
import type { PennDepartment, PennRegion } from "@penn/web-common";

export async function listDepartments(): Promise<PennDepartment[]> {
  const res = await Api.get("/v1/departments");
  return unwrap<PennDepartment[]>(res.data);
}

export async function listRegions(): Promise<PennRegion[]> {
  const res = await Api.get("/v1/regions");
  return unwrap<PennRegion[]>(res.data);
}
